<template>
    <div>
        <h2 v-if="!switchMode">{{ $t("wp.purchaseHeader") }}</h2>
        <span v-if="!switchMode"> {{ $t("wp.purchasePaymentDescription") }}</span>
        <h2 v-if="switchMode">{{ $t("wp.whatsappPlans") }}</h2>
        <span v-if="switchMode">{{ $t("wp.selectBestPlan") }}</span>
        <div class="plans mt-5">
            <WhatsappBasicPlanCard :selected="whatsappBasicEnabled" :on-selected="() => onPlanSelected('whatsapp')" />
            <WhatsappPlusPlanCard
                :selected="whatsappPlusEnabled"
                :on-selected="() => onPlanSelected('whatsapp-plus')"
            />
        </div>
    </div>
</template>

<script>
import { updateIntegration } from "../../api/billing";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import WhatsappBasicPlanCard from "./plans/WhatsappBasicPlanCard";
import WhatsappPlusPlanCard from "./plans/WhatsappPlusPlanCard";
import _ from "lodash";

export default {
    name: "Purchase",
    props: {
        purchaseCompleted: {
            type: Function,
            default: () => {},
        },
        switchMode: {
            type: Boolean,
            default: false,
        },
    },
    components: { WhatsappBasicPlanCard, WhatsappPlusPlanCard },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
            wpInfo: (state) => state.whatsapp.info,
            whatsappBasicEnabled: (state) => _.get(state.setting.settings, "whatsapp.enabled", false),
            whatsappPlusEnabled: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
        }),
        onPlanSelected(planType) {
            this.updateIntegration(planType, true);
        },
        async updateIntegration(key, status = false) {
            await updateIntegration(this.siteId, key, status);
            sendSocketMessage("user settings-updated", {
                siteId: this.siteId,
            });
            sendSocketMessage("user wp-purchase-event", {
                siteId: this.siteId,
            });
            this.getSettings();
            if (!this.switchMode) {
                this.changePurchaseStatus(status);
                this.purchaseCompleted();
            }
        },
    },
};
</script>
